module.exports = __webpack_public_path__ + "static/media/art76.71847988.jpg";